import { safeParse } from './stringHelpers';

const isBlank = (value) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

export const getCustomBookingFields = (restaurant, whereToShow) => {
  const widgetSettings = safeParse(restaurant?.data?.bookingWidgetSettings, {})?.widgetSettings;
  const fields = widgetSettings?.customBookingFields;

  if (!Array.isArray(fields)) {
    return [];
  }

  return whereToShow ? fields.filter((field) => field?.whereToShow === whereToShow) : fields;
};

export const validateCustomBookingFields = (fields, values = {}) =>
  fields.reduce((errors, field) => {
    const value = values[field.id];
    const valueIsBlank = isBlank(value) || (field.type === 'checkbox' && value !== true);

    if (field.required && valueIsBlank) {
      return { ...errors, [field.id]: 'This field is required.' };
    }

    if (isBlank(value) || field.type === 'checkbox' || field.type === 'date') {
      return errors;
    }

    const stringValue = String(value);
    const validationMethod = field?.options?.validationMethod;
    let isValid = true;

    if (validationMethod === 'alpha') {
      isValid = /^[a-zA-Z\s]+$/.test(stringValue);
    } else if (validationMethod === 'numeric') {
      isValid = /^\d+$/.test(stringValue);
    } else if (validationMethod === 'alphanumeric') {
      isValid = /^[a-zA-Z0-9\s]+$/.test(stringValue);
    } else if (validationMethod === 'regular_expression') {
      try {
        isValid = new RegExp(field?.options?.validationRegularExpression).test(stringValue);
      } catch {
        // A malformed venue configuration must not prevent a guest from booking.
        isValid = true;
      }
    }

    return isValid ? errors : { ...errors, [field.id]: 'Please enter a valid value.' };
  }, {});

export const buildCustomBookingFieldsPayload = (restaurant, values = {}) => {
  const fields = getCustomBookingFields(restaurant);
  const hasValue = fields.some((field) => !isBlank(values[field.id]));

  if (!hasValue) {
    return null;
  }

  return fields.map((field) => ({
    id: field.id,
    label: field.name,
    type: field.type,
    value: values[field.id] ?? null,
  }));
};
